import React from "react";
import {cn} from "../utils";

const QueueIcon = (
    {
        className,
        color
    }: {
        className?: string,
        color?: string
    } & React.SVGProps<SVGSVGElement>) => (

    <svg fill="none"
         height="512"
         width="512"
         viewBox="0 0 24 24"
         className={cn(className)}
         xmlns="http://www.w3.org/2000/svg">
        <path clipRule="evenodd"
              d="m2.25 6.23597c0-2.0443 2.15136-3.37391 3.97984-2.45967l3.52786 1.76393c2.0269 1.01344 2.0269 3.90591 0 4.91937l-3.52786 1.7639c-1.82848.9142-3.97984-.4154-3.97984-2.45967zm3.30902-1.11803c-.83113-.41557-1.80902.1888-1.80902 1.11803v3.52786c0 .92927.97789 1.53357 1.80902 1.11807l3.52786-1.76396c.92132-.46066.92132-1.77542 0-2.23607zm7.69098.88196c0-.41421.3358-.75.75-.75h7c.4142 0 .75.33579.75.75s-.3358.75-.75.75h-7c-.4142 0-.75-.33579-.75-.75zm0 5c0-.4142.3358-.75.75-.75h7c.4142 0 .75.3358.75.75s-.3358.75-.75.75h-7c-.4142 0-.75-.3358-.75-.75zm-11 5c0-.4142.33579-.75.75-.75h18c.4142 0 .75.3358.75.75s-.3358.75-.75.75h-18c-.41421 0-.75-.3358-.75-.75zm0 5c0-.4142.33579-.75.75-.75h18c.4142 0 .75.3358.75.75s-.3358.75-.75.75h-18c-.41421 0-.75-.3358-.75-.75z"
              fill={color || "currentColor"}
              fillRule="evenodd"/>
    </svg>
);

export {QueueIcon};